const STORAGE_KEYS = {
    ORIGIN: 'airport-origin',
    DESTINATION: 'airport-destination',
};

const DEFAULT_AIRPORT = {
    value: '',
    name: '',
    code: '',
    mainCode: '',
    countryCode: '',
    cityCode: '',
    cityName: '',
    isCity: false,
};

export const getOriginAirport = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.ORIGIN);
        if (stored) {
            return { ...DEFAULT_AIRPORT, ...JSON.parse(stored) };
        }
    } catch (error) {
        console.error('Error reading origin airport from localStorage:', error);
    }
};

export const getDestinationAirport = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.DESTINATION);
        if (stored) {
            return { ...DEFAULT_AIRPORT, ...JSON.parse(stored) };
        }
    } catch (error) {
        console.error('Error reading destination airport from localStorage:', error);
    }
};


export const setOriginAirport = (data) => {
    try {
        const airportData = {
            value: data.value || data.from || '',
            name: data.name || data.fromName || '',
            code: data.code || data.fromCode || '',
            mainCode: data.mainCode || data.fromMainCode || '',
            countryCode: data.countryCode || data.fromCountryCode || '',
            cityCode: data.cityCode || data.fromCityCode || '',
            cityName: data.cityName || '',
            isCity: data.isCity || false,
        };
        localStorage.setItem(STORAGE_KEYS.ORIGIN, JSON.stringify(airportData));
        
        syncToLegacyKeys('from', airportData);
    } catch (error) {
        console.error('Error saving origin airport to localStorage:', error);
    }
};

export const setDestinationAirport = (data) => {
    try {
        const airportData = {
            value: data.value || data.to || '',
            name: data.name || data.toName || '',
            code: data.code || data.toCode || '',
            mainCode: data.mainCode || data.fromMainCode || '',
            countryCode: data.countryCode || data.fromCountryCode || '',
            cityCode: data.cityCode || data.fromCityCode || '',
            cityName: data.cityName || '',
            isCity: data.isCity || false,
        };
        localStorage.setItem(STORAGE_KEYS.DESTINATION, JSON.stringify(airportData));
        
        syncToLegacyKeys('to', airportData);
    } catch (error) {
        console.error('Error saving destination airport to localStorage:', error);
    }
};


export const clearOriginAirport = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.ORIGIN);
        clearLegacyKeys('from');
    } catch (error) {
        console.error('Error clearing origin airport from localStorage:', error);
    }
};


export const clearDestinationAirport = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.DESTINATION);
        clearLegacyKeys('to');
    } catch (error) {
        console.error('Error clearing destination airport from localStorage:', error);
    }
};


export const swapAirports = () => {
    const origin = getOriginAirport();
    const destination = getDestinationAirport();
    
    setOriginAirport({
        value: destination.value,
        name: destination.name,
        code: destination.code,
        mainCode: destination.mainCode,
        countryCode: destination.countryCode,
        cityCode: destination.cityCode,
        cityName: destination.cityName,
        isCity: destination.isCity,
    });
    
    setDestinationAirport({
        value: origin.value,
        name: origin.name,
        code: origin.code,
        mainCode: origin.mainCode,
        countryCode: origin.countryCode,
        cityCode: origin.cityCode,
        cityName: origin.cityName,
        isCity: origin.isCity,
    });
};


export const decodeStorageValue = (value) => {
    if (!value) return '';
    try {
        return decodeURIComponent(value);
    } catch (_error) {
        return value;
    }
};


const syncToLegacyKeys = (prefix, data) => {
    localStorage.setItem(prefix, data.value);
    localStorage.setItem(`${prefix}-name`, data.name);
    localStorage.setItem(`${prefix}-code`, data.code);
    localStorage.setItem(`${prefix}-main-code`, data.mainCode);
    localStorage.setItem(`${prefix}-country-code`, data.countryCode);
    localStorage.setItem(`${prefix}-city-code`, data.cityCode);
};

const clearLegacyKeys = (prefix) => {
    localStorage.setItem(prefix, '');
    localStorage.setItem(`${prefix}-name`, '');
    localStorage.setItem(`${prefix}-code`, '');
    localStorage.setItem(`${prefix}-main-code`, '');
    localStorage.setItem(`${prefix}-country-code`, '');
    localStorage.setItem(`${prefix}-city-code`, '');
};


export const migrateLegacyAirportData = () => {
    const hasNewFormat = localStorage.getItem(STORAGE_KEYS.ORIGIN) || localStorage.getItem(STORAGE_KEYS.DESTINATION);
    
    if (!hasNewFormat) {
        const legacyOrigin = {
            value: localStorage.getItem('from') || '',
            name: localStorage.getItem('from-name') || '',
            code: localStorage.getItem('from-code') || '',
            mainCode: localStorage.getItem('from-main-code') || '',
            countryCode: localStorage.getItem('from-country-code') || '',
            cityCode: localStorage.getItem('from-city-code') || '',
        };
        
        const legacyDestination = {
            value: localStorage.getItem('to') || '',
            name: localStorage.getItem('to-name') || '',
            code: localStorage.getItem('to-code') || '',
            mainCode: localStorage.getItem('to-main-code') || '',
            countryCode: localStorage.getItem('to-country-code') || '',
            cityCode: localStorage.getItem('to-city-code') || '',
        };
        
        if (legacyOrigin.code || legacyOrigin.name) {
            localStorage.setItem(STORAGE_KEYS.ORIGIN, JSON.stringify(legacyOrigin));
        }
        
        if (legacyDestination.code || legacyDestination.name) {
            localStorage.setItem(STORAGE_KEYS.DESTINATION, JSON.stringify(legacyDestination));
        }
    }
};
